import {
  Autocomplete as MantineAutocomplete,
  type AutocompleteProps as MantineAutocompleteProps,
} from "@mantine/core"
import { forwardRef, useState } from "react"

import { Label } from "../../../atoms/Label/Label"
import { EqualWidthGrid } from "../../../layout/EqualWidthGrid/EqualWidthGrid"
import { Loader } from "../../../molecules/Loader/Loader"

export type AutocompleteProps = {
  isLoading?: boolean
  inlineLabel?: boolean
  errorOnTouch?: boolean
} & MantineAutocompleteProps

export const Autocomplete = forwardRef<HTMLInputElement, AutocompleteProps>(
  (
    {
      isLoading = false,
      inlineLabel = false,
      errorOnTouch = true,
      label,
      error,
      onBlur,
      onClear,
      rightSection,
      ...props
    },
    ref
  ) => {
    const [touched, setTouched] = useState(false)
    const clearable = isLoading ? false : props.clearable

    const input = (
      <MantineAutocomplete
        ref={ref}
        label={inlineLabel ? undefined : label}
        rightSection={isLoading ? <Loader size="xs" /> : rightSection}
        clearable={clearable}
        onBlur={(event) => {
          setTouched(true)
          onBlur?.(event)
        }}
        onClear={() => {
          setTouched(true)
          onClear?.()
        }}
        error={errorOnTouch ? touched && error : error}
        {...props}
      />
    )

    return inlineLabel ? (
      <EqualWidthGrid>
        <Label label={label} />
        {input}
      </EqualWidthGrid>
    ) : (
      input
    )
  }
)

Autocomplete.displayName = "Autocomplete"
